export default __webpack_public_path__ + "static/media/Extracted_Human_DNA.0be003bb.svg";